import { render, staticRenderFns } from "./Pagedetails.vue?vue&type=template&id=39367d85&scoped=true"
import script from "./Pagedetails.vue?vue&type=script&lang=js"
export * from "./Pagedetails.vue?vue&type=script&lang=js"
import style0 from "./Pagedetails.vue?vue&type=style&index=0&id=39367d85&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f1c606d12331ca9397f00d9371f47138/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39367d85",
  null
  
)

export default component.exports